export type paramObj = {
  [key: string]: string[]
}
/**
 * shallowCompare compare 2 objects to check if they are identical. It's mainly used for comparing parsed params list of games to compare and user settings
 * @param firstObj
 * @param secondObj
 * @returns whether 2 objects is identical
 */
export const shallowCompare = (firstObj?: paramObj, secondObj?: paramObj): boolean => {
  if (!firstObj || !secondObj) return false

  const firstKeys = Object.keys(firstObj)
  const secondKeys = Object.keys(secondObj)

  if (firstKeys.length !== secondKeys.length) {
    return false
  }

  for (const gameId of firstKeys) {
    if (!secondKeys.includes(gameId)) {
      return false
    }

    const a = [...firstObj[gameId]].sort()
    const b = [...secondObj[gameId]].sort()

    if (a.length !== b.length || a.some((v, i) => v !== b[i])) {
      return false
    }
  }

  return true
}
